import React, { useState } from "react";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import TagIcon from '@mui/icons-material/Tag';
import CallIcon from '@mui/icons-material/Call';
import TextField from "@mui/material/TextField";
import Accordion from "@mui/material/Accordion";
import EmailIcon from '@mui/icons-material/Email';
import SearchIcon from "@mui/icons-material/Search";
import PersonIcon from '@mui/icons-material/Person';
import BusinessIcon from '@mui/icons-material/Business';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import "../../../assets/styles/containers/_placeholder.scss";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import { ArrowDown } from "../../../assets/svgIcons/Svg";
import Signature from "../../../assets/images/Signature.svg";
import { Grid } from "@mui/material";
const Placeholder = (props) => {

  const placeholderData = {
    categories: [
      {
        category: "MOST USED",
        values: [
          { title: "Inspector Name", value: "%inspectordisplayname%", icon: <PersonIcon />, },
          { title: "Company Phone", value: "{{Company_Phone}}", icon: <CallIcon /> },
          { title: "Company Email", value: "{{Company_Email}}", icon: <EmailIcon /> },
          { title: "Client Name", value: "{{Client_Name}}", icon: <PersonIcon /> },
          { title: "Property Address", value: "{{Property_Address}}", icon: <LocationOnIcon /> },
          { title: "Property CSZ", value: "{{Property_CSZ}}", icon: <BookmarkBorderIcon /> },
          { title: "Inspection Date", value: "{{Inspection_Date}}", icon: <CalendarMonthIcon /> },
        ]
      },
      {
        category: "INSPECTION",
        values: [
          { title: "Property Photo", value: "%propertyphoto-350%", icon: <LocationOnIcon /> },
          { title: "Client Name", value: "%clientsdisplayname%", icon: <PersonIcon /> },
          { title: "Inspection Date", value: "%inspectiondate-nice%", icon: <CalendarMonthIcon /> },
          { title: "Property Address", value: "%address1%", icon: <LocationOnIcon /> },
          { title: "Property CSZ", value: "%city%%state%%zip%", icon: <BookmarkBorderIcon /> },
        ]
      },
      {
        category: "INSPECTOR",
        values: [
          { title: "Primary Inspector", value: "%inspectordisplayname%", icon: <PersonIcon /> },
          { title: "2nd Inspector", value: "%inspector2displayname%}", icon: <PersonIcon /> },
          { title: "3rd Inspector", value: "%inspector3displayname%}", icon: <PersonIcon /> },
          { title: "4th Inspector", value: "%inspector4displayname%}", icon: <PersonIcon /> },
          { title: "5th Inspector", value: "%inspector5displayname%}", icon: <PersonIcon /> },
          { title: "6th Inspector", value: "%inspector6displayname%}", icon: <PersonIcon /> },
          { title: "7th Inspector", value: "%inspector7displayname%}", icon: <PersonIcon /> },
          { title: "8th Inspector", value: "%inspector8displayname%}", icon: <PersonIcon /> },
          { title: "9th Inspector", value: "%inspector9displayname%}", icon: <PersonIcon /> },
          { title: "10th Inspector", value: "%inspector10displayname%}", icon: <PersonIcon /> },
        ]
      },
      {
        category: "COMPANY",
        values: [
          { title: "Company Name", value: "{{Company_Name}}", icon: <BusinessIcon /> },
          { title: "Company Phone", value: "%officephone%", icon: <CallIcon /> },
          { title: "Company Address", value: "%companyaddress%", icon: <LocationOnIcon /> },
          { title: "Company CSZ", value: "%companycity%%companystate% %companyzip%", icon: <BookmarkBorderIcon /> }
        ]
      }
    ]
  }
  const inspectorDetails = [{ title: "Inspector Name", icon: <PersonIcon /> }, { title: "Inspector License", icon: <TagIcon /> }, { title: "Inspector Signature" }, { title: "Inspector Phone", icon: <CallIcon /> }, { title: "Inspector Email", icon: <EmailIcon /> }]

  const [placeholderValues, setPlaceHolderValues] = useState(placeholderData);
  const [expanded, setExpanded] = useState(null);

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const searchPlaceholders = (query) => {
    if (!query) {
      setPlaceHolderValues(placeholderData);
      return;
    }

    query = query.toLowerCase();

    const filteredCategories = placeholderData.categories
      .map((categoryObj) => {
        const filteredValues = categoryObj.values.filter(
          (item) =>
            item.title.toLowerCase().includes(query)
        );

        return filteredValues.length > 0
          ? { ...categoryObj, values: filteredValues }
          : null;
      })
      .filter(Boolean);

    setPlaceHolderValues({ categories: filteredCategories });
  };


  // For Button
  // const handleInsertPlaceholder = (placeholder) => {
  //   const editorInstance = props.editor.current.editor;
  //   if (editorInstance) {
  //     const placeholderHTML = `<span contenteditable="false" style="
  //           display: inline-flex;
  //           align-items: center;
  //           background-color: #F4F8FF;
  //           padding: 4px 12px 4px 12px;
  //           border-radius: 6px;
  //           height:22px;
  //           font-size: 12px;
  //           font-weight:600;
  //           line-height:20px;
  //           color: #333;
  //           border: 1px solid #E6E6E6;
  //           font-size: 14px;
  //           font-family: Open Sans;
  //           cursor: pointer;
  //           white-space: nowrap;
  //           margin: 0 3px;
  //       ">${placeholder}</span>&nbsp;`;
  //     editorInstance.selection.save();
  //     editorInstance.html.insert(placeholderHTML, false);
  //     editorInstance.selection.restore();
  //   }
  // };


  // For PlaceHolder
  const handleInsertPlaceholder = (placeholder) => {
    const editorInstance = props.editor.current.editor;
    if (editorInstance) {
      const placeholderHTML = `{{${placeholder}}}`;
      editorInstance.selection.save();
      editorInstance.html.insert(placeholderHTML, false);
      editorInstance.selection.restore();
      props.setEditorContent((prevState) => ({ ...prevState, innerHTML: placeholderHTML }));
    }
  };


  return (
    <div className="sticky-mergeField">
      <div className="placeholder-search">
        <TextField
          id="search-bar"
          onChange={(e) => {
            searchPlaceholders(e.target.value);
          }}
          variant="outlined"
          placeholder="Search"
          size="small"
        />
        <SearchIcon className="search-merge" />
      </div>
      <div className="placeholder">
        {placeholderValues?.categories?.map((category, index) => (
          <div className="placeholder-category">
            <h4 className="category-title">{category.category}</h4>
            {category?.category === "INSPECTOR" ? category.values.map((item, idx) => (
              <Accordion expanded={expanded === item.title} onChange={handleAccordionChange(item.title)} className="inspector-details">
                <AccordionSummary className="ph-category-title"
                  expandIcon={<ArrowDown />}>{item.title}</AccordionSummary>
                <AccordionDetails>
                  {inspectorDetails.map((obj, ind) => <Grid container>
                    <Grid container>
                      {obj.title === "Inspector Signature" ? <Grid mt={1} ml={0.8} item xs={1}>
                        <img src={Signature} />
                      </Grid> : null}
                      <Grid item xs={10}>
                        <Button className="placeholder-button inspector-title" onClick={() => handleInsertPlaceholder(item.title.split(" ")[0] + " " + obj.title)} startIcon={obj.icon}>{obj.title}</Button>
                      </Grid>
                    </Grid>
                  </Grid>)}
                </AccordionDetails></Accordion>
            )) : category.values.map((item, idx) => (
              <Button className="placeholder-button" onClick={() => handleInsertPlaceholder(item.title)} startIcon={item?.icon}>{item.title}</Button>
            ))}
            {index + 1 !== placeholderValues?.categories?.length ? <Divider /> : ""}
          </div>
        ))}
        {placeholderValues?.categories?.length === 0 && <div style={{ textAlign: "center", fontStyle: "italic" }}>No Data Found</div>}
      </div>
    </div>
  );
};

export default Placeholder;